/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconPaper extends React.Component {
  render() {
    const iconClasses = classNames("icon paper", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path
          d="M 7 3 A 1.0001 1.0001 0 0 0 6 4 L 6 17 L 8 17 L 8 5 L 24 5 L 24 22 C 24 23.668484 22.668484 25 21 25 C 19.331516 25 18 23.668484 18 22 L 18 20 A 1.0001 1.0001 0 0 0 17 19 L 4 19 A 1.0001 1.0001 0 0 0 3 20 L 3 22 C 3 24.749516 5.2504839 27 8 27 L 21 27 A 1.0001 1.0001 0 0 0 21.099609 26.994141 C 23.803228 26.940077 26 24.715922 26 22 L 26 4 A 1.0001 1.0001 0 0 0 25 3 L 7 3 z"
          style={{
            lineHeight: "normal",
            textIndent: 0,
            textAlign: "start",
            textDecorationLine: "none",
            textDecorationStyle: "solid",
            textDecorationColor: "#000",
            textTransform: "none",
            blockProgression: "tb",
            isolation: "auto",
            mixBlendMode: "normal",
            fontWeight: 400,
            fontFamily: "sans-serif",
            whiteSpace: "normal",
            overflow: "visible"
          }}
        />
      </svg>
    );
  }
}

IconPaper.defaultProps = {
  className: null
};

IconPaper.propTypes = {
  className: PropTypes.string
};

export default IconPaper;
